module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "company-dialog"
    }
  }, [_c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": _vm.title,
      "custom-class": "company-dialog"
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('el-form-item', [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }],
    attrs: {
      "auto-complete": "off",
      "placeholder": "企业名称（必填）"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": function($event) {
        _vm.company.name = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.legalPerson),
      expression: "company.legalPerson"
    }],
    attrs: {
      "auto-complete": "off",
      "placeholder": "联系人（必填）"
    },
    domProps: {
      "value": (_vm.company.legalPerson)
    },
    on: {
      "input": function($event) {
        _vm.company.legalPerson = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.address),
      expression: "company.address"
    }],
    attrs: {
      "auto-complete": "off",
      "placeholder": "邮寄地址（非必填）"
    },
    domProps: {
      "value": (_vm.company.address)
    },
    on: {
      "input": function($event) {
        _vm.company.address = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%",
      "background": "#007fff",
      "border-radius": "2px",
      "border": "none",
      "padding": "0.7em",
      "font-size": "18px"
    },
    attrs: {
      "id": "btn-submit",
      "type": "primary",
      "loading": _vm.inSubmit
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.inSubmit ? "提交中" : "确定") + "\n\n\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-f6365726!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanyDialog.vue
// module id = 1074
// module chunks = 40